<template>
  <a class="menu-button" @click="$root.menuOpen = !$root.menuOpen; $root.shareOpen = false">
    <div class="menu-button-bars">
      <span class="menu-button--bar"></span>
      <span class="menu-button--bar"></span>
      <span class="menu-button--bar"></span>
    </div>
  </a>
</template>
<script>
export default {
  name: 'MenuButton'
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';

#app {
  &.menu-opened {
    .menu-button {
      background: $white;
    }
    .menu-button--bar {
      background: #C1C1C3;
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(1) {
        transform: translate(0, 5px) rotate(45deg);
      }
      &:nth-child(3) {
        transform: translate(0, -7px) rotate(-45deg) ;
      }
    }
  }
  &.submenu-opened {
    @media(min-width: $screen-sm-min) {
      .menu-button {
        right: -($sidenav-width + 60px);
      }
    }
  }
  &.belowhero {
    .menu-button {
      background: $white;
      .menu-button--bar {
        background: $green-light;
      }
    }
  }
}
.menu-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -2px;
  .menu-button--bar {
    display: block;
    width: 20px;
    height: 2px;
    background: $white;
    margin-top: 4px;
    transition: .4s all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuButton.vue